// 見本の広告。AdSense の審査の前でも、広告の枠の流れ（止める→出す→戻す）を確かめられる。
import { t } from "../i18n";
import { h } from "../ui/dom";
import type { AdProvider } from "./types";

const INTERSTITIAL_MS = 2_500;
const REWARD_MS = 5_000;

function overlay(kind: "interstitial" | "rewarded"): Promise<boolean> {
  return new Promise((resolve) => {
    const count = h("p", { class: "ad-count", "aria-live": "polite" });
    const claim = h("button", { class: "btn-mini", type: "button", hidden: true }, t("ads.rewardReady"));
    const skip = h("button", { class: "btn-text", type: "button" }, kind === "rewarded" ? t("ads.skip") : t("common.close"));
    const box = h(
      "div",
      { class: "ad-overlay", role: "dialog", "aria-modal": "true", "aria-label": t("ads.label"), "data-ad": kind },
      h(
        "div",
        { class: "ad-box" },
        h("span", { class: "ad-l" }, t("ads.label")),
        h("p", { class: "ad-sample ph" }, t("ads.sample")),
        count,
        h("div", { class: "ad-actions" }, skip, claim),
      ),
    );
    // 全画面の表示の中でも見えるように、全画面の要素があればその中に出す
    (document.fullscreenElement ?? document.body).append(box);
    const started = Date.now();
    const done = (granted: boolean) => {
      clearInterval(timer);
      box.remove();
      resolve(granted);
    };
    const total = kind === "rewarded" ? REWARD_MS : INTERSTITIAL_MS;
    const tick = () => {
      const left = Math.max(0, Math.ceil((total - (Date.now() - started)) / 1000));
      if (kind === "rewarded") {
        count.textContent = left > 0 ? t("ads.rewardWait", { n: left }) : "";
        if (left === 0) {
          claim.hidden = false;
          skip.hidden = true;
        }
      } else if (left === 0) {
        done(true);
      }
    };
    const timer = setInterval(tick, 200);
    tick();
    claim.addEventListener("click", () => done(true));
    skip.addEventListener("click", () => done(kind === "interstitial"));
  });
}

export const dummyAds: AdProvider = {
  name: "dummy",
  async interstitial() {
    return { shown: await overlay("interstitial") };
  },
  async rewarded() {
    return { granted: await overlay("rewarded") };
  },
  mountBanner(el, slot) {
    el.classList.add("ad");
    el.dataset.slot = slot;
    el.replaceChildren(h("span", { class: "ad-l" }, t("ads.label")), h("span", { class: "ad-t" }, t("ads.banner")));
  },
};
